function isCompleteOtp(value) {
  return /^\d{6}$/.test(String(value == null ? "" : value));
}

const OTP_INVALID_MESSAGE = "請輸入 6 位短訊認證碼";

function assertSixDigitOtp(value, onInvalid) {
  if (isCompleteOtp(value)) {
    return true;
  }
  if (typeof onInvalid === "function") {
    onInvalid(OTP_INVALID_MESSAGE);
  }
  return false;
}

module.exports = { isCompleteOtp, assertSixDigitOtp, OTP_INVALID_MESSAGE };
